/**
 * Human-readable label for a level in dropdowns/lists.
 * Includes branch when available so duplicate names (e.g. Beginner) are distinguishable.
 */
import i18n from '../i18n';

export function formatLevelLabel(level) {
    if (!level) return "—";
    const id = level.levelId ?? level.id;
    const name = (level.name ?? level.levelName ?? i18n.t('levels.unnamed', { defaultValue: 'Level' })).trim();
    const branch = (level.branchName ?? level.branch?.name ?? "").trim();
    const idSuffix = id != null ? ` (#${id})` : "";
    if (branch) return `${branch} — ${name}${idSuffix}`;
    return `${name}${idSuffix}`;
}
